/**
 * All of these are available to override by environment variable in case the values need adjusted as the
 * number of syncing tables grows, etc.
 */
export const SCHEDULED_EXTRACTION_TIMING_TEXT =
  process.env.ANALYTICS_SYNC_SCHEDULED_EXTRACTION_TIMING ||
  '30 minutes after the hour (e.g. 12:30)';
export const ESTIMATED_COST_FOR_SYNC_TEXT =
  process.env.ANALYTICS_SYNC_ESTIMATED_COST_FOR_SYNC || '$1';
export const TIME_FOR_SYNC_TO_COMPLETE_TEXT =
  process.env.ANALYTICS_SYNC_TIME_FOR_SYNC_TO_COMPLETE || '15 minutes';
